import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { T } from '../traks';
import { A } from '../routes';
import SearchField from '../c/SearchField';
import { Apify } from '../Apify';
import store from '../store';
import { StockCard } from '../c/ChartCard';
import XTab from '../c/XTab';
import { connect } from 'react-redux';
import { ordered_and_available_market_ids, available_markets_set } from '../markets';

const mk_stock_list_title = (alt, src, text) => <React.Fragment><img alt={alt} src={src} className="ad_explore_xtab_icon" /><span className="d-none d-md-inline-block">&nbsp;{text}</span></React.Fragment>;
const stocklists = [
	{
		title: mk_stock_list_title("USA", "/gfx/usa-icon-0.svg", <T>stock</T>),
		market: "US_STOCK",
	},
	{
		title: mk_stock_list_title("DK", "/gfx/denmark-icon-0.svg", <T>stock</T>),
		market: "DK_STOCK",
	},
	{
		title: mk_stock_list_title("SE", "/gfx/sweden-icon-0.svg", <T>stock</T>),
		market: "SE_STOCK",
	},
	{
		title: mk_stock_list_title("FI", "/gfx/finland-icon-0.svg", <T>stock</T>),
		market: "FI_STOCK",
	},
	{
		title: <React.Fragment><img alt="DE" src="/gfx/germany-icon-0.svg" className="ad_explore_xtab_icon" /><span className="d-none d-md-inline-block">&nbsp;<T>stock</T></span></React.Fragment>,
		market: "DE_STOCK",
	},
	{
		title: mk_stock_list_title("Crypto", "/gfx/crypto-icon-0.svg", <T>Crypto</T>),
		market: "CRYPTOCURRENCIES",
	},

].filter(x => available_markets_set[x.market]);

const stocklist_intervals = [
	{
		title: <React.Fragment><span className="d-none d-md-inline-block"><T>Today</T></span><span className="d-md-none">1d</span></React.Fragment>,
		key:  "1d",
	},
	{
		title: <React.Fragment><span className="d-none d-md-inline-block"><T>7 days</T></span><span className="d-md-none">7d</span></React.Fragment>,
		key:  "7d",
	},
	{
		title: <React.Fragment><span className="d-none d-md-inline-block"><T>30 days</T></span><span className="d-md-none">1m</span></React.Fragment>,
		key:  "1m",
	},
];

function get_stocklists_stuff_for_props(props) {
	const market = stocklists[props.stocklist_xtab_index].market;
	const iv = stocklist_intervals[props.stocklist_interval_xtab_index];
	const interval = iv.key;
	return {market, interval}
}

var StockLists = (props) => {
	if (props.error) return null;

	const range = get_stocklists_stuff_for_props(props).interval;

	var tabs = [];
	for (const stocklist of stocklists) tabs.push(stocklist.title);

	var cards = [];
	for (var i = 0; i < props.stocklists.length; i++) {
		const e = props.stocklists[i];
		cards.push(
			<Col key={`${e.Exchange}:${e.Ticker}:${range}`} md="3" className="p-3">
				<StockCard
					exchange={e.Exchange}
					ticker={e.Ticker}
					range={range}
				/>
			</Col>
		);
	}

	const on_stocklist_select = (i) => {
		store.dispatch_value("home_stocklist_xtab_index", i);
	};

	const on_interval_select = (i) => {
		store.dispatch_value("home_stocklist_interval_xtab_index", i);
	};

	const intervals = stocklist_intervals.map(i => i.title);

	return (
		<Row className="ad_game_box p-0">
			<Col xs="12" className="pt-4 px-2 px-md-4">
				<div className="d-flex">
					<div className="ad_150pct"><b><T>Boomers</T></b></div>
				</div>
				<XTab
					row_classes="pb-0"
					left_selected={props.stocklist_xtab_index}
					onLeftSelect={on_stocklist_select}
					left_tabs={tabs}

					right_selected={props.stocklist_interval_xtab_index}
					onRightSelect={on_interval_select}
					right_tabs={intervals}
				/>
			</Col>
			<Col xs="12" className="p-0">
				<Container fluid className="">
					<Row className="p-0 ad_game_card_box_bg">
						{cards}
					</Row>
				</Container>
			</Col>
		</Row>
	);
}

StockLists = Apify("/z/stock_change_list")
	.with_query_from_props((props) => {
		const { market, interval } = get_stocklists_stuff_for_props(props);
		return { name: market, interval, kind: "top" };
	})
	.with_response_prop("stocklists")
	.with_4xx_prop("error")
	.wrap(StockLists);

var MarketCard = (props) => {
	const srcset = props.imgsrc_1x + " 1x, " + props.imgsrc_2x + " 2x";
	return (
			<Col xs="12" lg="6" className="pb-5 ad_market_card">
				<A className="ad_no_hover" href={props.href}>
				<div className="ad_150pct"><b>{props.title}</b></div>
				<div className="py-3 ad_market_card">
					<img
						className="ad_market_card"
						alt={props.title}
						src={props.imgsrc_1x}
						srcSet={srcset}
					/>
				</div>
				</A>
				<div>
					{props.market_txt}
				</div>
			</Col>
	);
}

var ExploreMarkets = (props) => {
	const us_title = <T>American Market</T>;
	const us_market_txt = <T>The <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/New_York_Stock_Exchange">New York Stock Exchange (NYSE)</a> and the <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/NASDAQ">Nasdaq Stock Market</a> were founded in 1792 and 1971, respectively. NYSE is by far the largest stock exchange in the world by market capitalization.</T>;
	const dk_title = <T>Danish Market</T>;
	const dk_market_txt = <T>The <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Copenhagen_Stock_Exchange">Copenhagen Stock Exchange (Nasdaq Copenhagen since 2014)</a> was founded in 1625 and was located in the <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/B%C3%B8rsen">Børsen building (image above)</a> until 1974.</T>;
	const se_title = <T>Swedish Market</T>;
	const se_market_txt = <T>The <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Stockholm_Stock_Exchange">Stockholm Stock Exchange (Nasdaq Stockholm since 2008)</a> was founded in 1863 and was located in the <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Stockholm_Stock_Exchange_Building">Börshuset building</a> until 1998.</T>;
	const fi_title = <T>Finnish Market</T>;
	const fi_market_txt = <T>The <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Helsinki_Stock_Exchange">Helsinki Stock Exchange (Nasdaq Helsinki since 2008)</a> was founded in 1912.</T>
	const de_title = <T>German Market</T>;
	const de_market_txt = <T>The <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Frankfurt_Stock_Exchange">Frankfurt Stock Exchange</a> is owned and operated by Deutsche Börse AG. There's actually seven regional exchanges in Germany, with the one in Frankfurt being the main one. Also known as XETRA.</T>;
	const is_title = <T>Icelandic Market</T>;
	const is_market_txt = <T>The <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Iceland_Stock_Exchange">Iceland Stock Exchange (Nasdaq Iceland since 2008)</a> began trading in 1986.</T>
	const commodity_title = <T>Commodity Market</T>;
	const commodity_market_txt = <T>We have several metals and oil in our commodity section.</T>;
	const currency_title = <T>Currency Market</T>;
	const currency_market_txt = <T>We support the purchasing of a number of currencies. The exchange rates follow the rates from the <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Danmarks_Nationalbank">National Bank of Denmark</a>.</T>;
	const crypto_title = <T>Crypto Market</T>;
	const crypto_market_txt = <T>We mirror the crypto currencies traded on the crypto exchanges. The different currencies will be listed and de-listed based on the volume traded. A certain volume is needed before you can trade it in our game.</T>;
    const etf_title = <T>ETFs</T>
    const etf_market_text = <T>An exchange-traded fund (ETF) is a pooled investment security that can be bought and sold like an individual stock. ETFs can be structured to track anything from the price of a commodity to a large and diverse collection of securities.</T>
    const indexes_title = <T>Indexes</T>
    const indexes_market_text = <T>A financial index produces a numeric score based on inputs such as a variety of asset prices. It can be used to track the performance of a group of assets in a standardized way. Indexes typically measure the performance of a basket of securities intended to replicate a certain area of the market.</T>
    const funds_title = <T>Funds / Bonds</T>
    const funds_market_text = <T>A bond fund is a mutual fund or an exchange-traded fund (ETF) that buys and sells debt instruments like government and corporate bonds. The primary goal of a bond fund is to generate monthly income for investors.</T>

	const market_card_map = {
		"DK_STOCK": (
			<MarketCard
				key="dk"
				href="/explore-cph"
				title = {dk_title}
				market_txt = {dk_market_txt}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/borsenCPH-475x213-0.jpg"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/borsenCPH-950x425-0.jpg"
			/>
		),
		"SE_STOCK": (
			<MarketCard
				key="se"
				href = "/explore-sto"
				title = {se_title}
				market_txt = {se_market_txt}
				imgsrc_1x = {"https://static.aktiedysten.dk/imgs/swedishacademySTO-475x213-0.jpg"}
				imgsrc_2x = {"https://static.aktiedysten.dk/imgs/swedishacademySTO-950x425-0.jpg"}
			/>
		),
		"DE_STOCK": (
			<MarketCard
				key="de"
				href = "/explore-xetra"
				title = {de_title}
				market_txt = {de_market_txt}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/xetra-475x213-0.jpg"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/xetra-950x425-0.jpg"
			/>
		),
		"US_STOCK": (
			<MarketCard
				key="us"
				href="/explore-us"
				title = {us_title}
				market_txt = {us_market_txt}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/nyse-475x213-0.jpg"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/nyse-950x425-0.jpg"
			/>
		),
		"FI_STOCK": (
			<MarketCard
				key="fi"
				href = "/explore-hel"
				title = {fi_title}
				market_txt = {fi_market_txt}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/lakesHEL-475x213-0.jpg"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/lakesHEL-950x425-0.jpg"
			/>
		),
		"IS_STOCK": (
			<MarketCard
				key="is"
				href = "/explore-ice"
				title = {is_title}
				market_txt = {is_market_txt}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/geysirICE-475x213-0.jpg"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/geysirICE-950x425-0.jpg"
			/>
		),
		"FOREX": (
			<MarketCard
				key="forex"
				href="/explore-bank"
				title = {currency_title}
				market_txt = {currency_market_txt}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/moneyroll-475x213-0.jpg"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/moneyroll-950x425-0.jpg"
			/>
		),
		"CRYPTOCURRENCIES": (
			<MarketCard
				key="crypto"
				href="/explore-crypto"
				title = {crypto_title}
				market_txt = {crypto_market_txt}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/cryptocoins-475x213-0.jpg"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/cryptocoins-950x425-0.jpg"
			/>
		),
        "COMMODITIES": (
            <MarketCard
				key="commodity"
				href="/explore-commodities"
				title = {commodity_title}
				market_txt = {commodity_market_txt}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/goldsilver-475x213-0.jpg"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/goldsilver-950x425-0.jpg"
			/>
        ),
        "ETFS": (
            <MarketCard
				key="etfs"
				href="/explore-etfs"
				title = {etf_title}
				market_txt = {etf_market_text}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/etf-475x213-0.png"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/etf-950x425-0.png"
			/>
        ),
        "INDEXES": (
            <MarketCard
				key="indexes"
				href="/explore-indexes"
				title = {indexes_title}
				market_txt = {indexes_market_text}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/index-475x213-0.png"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/index-950x425-0.png"
			/>
        ),
        "FUNDS": (
            <MarketCard
				key="funds"
				href="/explore-funds"
				title = {funds_title}
				market_txt = {funds_market_text}
				imgsrc_1x = "https://static.aktiedysten.dk/imgs/fond-475x213-0.png"
				imgsrc_2x = "https://static.aktiedysten.dk/imgs/fond-950x425-0.png"
			/>
        )
	};

	const columns_per_row = 2;
	let rows = [];
	let row = [];
	for (const market_id of ordered_and_available_market_ids) {
		const card = market_card_map[market_id];
		if (!card) continue;
		row.push(card);
		if (row.length >= columns_per_row) {
			rows.push(row);
			row = [];
		}
	}
	if (row.length > 0) rows.push(row);

	let row_elements = [];
	for (let i = 0; i < rows.length; i++) {
		row_elements.push(
			<Row key={"row"+i} className="px-0 justify-content-around">
				{rows[i]}
			</Row>
		);
	}

	return (
		<Container>
			<Row className="p-2 pt-4">
				<Col xs="12" md="6" className="px-2">
					<h2><T>Explore markets</T></h2>
					<div className="py-4"><T>Welcome to our explore markets section. Here you can delve deeper into the five main market areas we support (more will follow in the future), and look at current boomers across the markets.</T>
					</div>
				</Col>
				<Col xs="12" md="6" className="pl-2" >
					<div className="d-block d-md-none">
						<b><T>Search:</T></b>
					</div>
					<div className="d-flex justify-content-lg-end">
						<SearchField form_classes="pb-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
					</div>
					<div className="d-block pb-4 d-md-none"/>
				</Col>
			</Row>
			<Container fluid className="ad_game_box pt-4">
			{row_elements}
			</Container>
			<Container fluid className="pt-4">
				<StockLists {...props}/>
			</Container>
		</Container>
	);
}

ExploreMarkets = connect(
	(state) => ({
		me: state.me,
		games_xtab_index: state.home_games_xtab_index,
		stocklist_xtab_index: state.home_stocklist_xtab_index,
		stocklist_interval_xtab_index: state.home_stocklist_interval_xtab_index,
	})
)(ExploreMarkets);

export default ExploreMarkets;



// WEBPACK FOOTER //
// ./src/p/ExploreMarkets.js